import React                from "react";
import Styled               from "styled-components";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import ActivityEdit         from "./ActivityEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";
import Image                from "Dashboard/Components/Common/Image";



// Styles
const IconImage = Styled(Image)`
    border-radius: var(--border-radius-small);
    margin: 2px 0;
`;



/**
 * The Activity List
 * @returns {React.ReactElement}
 */
function ActivityList() {
    const { fetch, load } = useList("activity");

    const data = Store.useState("activity");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("activity");


    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "activityID", elemID, "name");

    return <Main>
        <Header message="ACTIVITIES_NAME" icon="activity">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="ACTIVITIES_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="image"     message=""                    noSorting noSpace maxWidth="60" />
                    <TableHeader field="name"      message="GENERAL_NAME"        isFlex isTitle />
                    <TableHeader field="showInApp" message="GENERAL_SHOW_IN_APP" isFlex maxWidth="130" align="center" hideMobile />
                    <TableHeader field="position"  message="GENERAL_POSITION"    isFlex maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.activityID} elemID={elem.activityID}>
                        <TableCell>
                            <IconImage
                                source={elem.imageThumb}
                                message={elem.name}
                                size="48"
                            />
                        </TableCell>
                        <TableCell message={elem.name}          />
                        <TableCell message={elem.showInAppText} />
                        <TableCell message={elem.position}      />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="VIEW"   message="ACTIVITIES_VIEW_TITLE"   navigate />
                    <TableAction action="EDIT"   message="ACTIVITIES_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="ACTIVITIES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <ActivityEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="ACTIVITIES_DELETE_TITLE"
            message="ACTIVITIES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default ActivityList;
